import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/authContext.tsx';
import MiniDrawer from '../pages/drawer/Drawer.js';
import { Box, useMediaQuery } from '@mui/material';
import LoadingComponent from '../components/loadingComponent/index.tsx';
import { useSelector } from 'react-redux';

interface LoadingState {
  isLoading: boolean;
}

export const PrivateRoute: React.FC = () => {
  const { isAuthenticated, CurrentVersionUpdated } = useAuth();
  const isMobile = useMediaQuery('(max-width: 680px)');
  const { isLoading } = useSelector((state: { loading: LoadingState }) => state.loading);

  if (!isAuthenticated || !CurrentVersionUpdated) {
    return <Navigate to="/login" />;
  }

  return (
    <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} width="100%">
      <MiniDrawer />
      <Box
        component="main"
        sx={{
          backgroundColor: '#B2BEC3',
          flexGrow: 1,
          padding: 1,
          boxSizing: 'border-box',
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
      {isLoading ? <LoadingComponent /> : null}
    </Box>
  );
};
